import React, { useState, useEffect } from 'react';
import useAuth from '../../../hooks/useAuth';
import { servicesService } from '../../../services/servicesService';
import { serviceRequestService } from '../../../services/serviceRequestService';
import { useNavigate } from 'react-router-dom';

const Services = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [services, setServices] = useState([]);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const data = await servicesService.getAllServices();
                setServices(data.services || data);
            } catch (error) {
                console.error("Failed to fetch services:", error);
            }
        };
        fetchServices();
    }, []);

    const handleRequestService = async (service) => {
        if (!user.email) {
            navigate('/signin');
            return;
        }
        
        const requestData = {
            serviceId: service._id,
            serviceTitle: service.title,
            email: user.email,
            userName: user.displayName,
            status: 'Pending'
        };

        try {
            await serviceRequestService.addRequest(requestData);
            alert(`Successfully requested: ${service.title}`);
        } catch (error) {
            console.error("Failed to request service:", error);
            alert("Failed to request service. Please try again.");
        }
    };

    return (
        <div className="py-24 bg-slate-50">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
                <div className="text-center mb-20">
                    <h3 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight lowercase">our premium <span className="text-amber-500">services</span></h3>
                    <div className="w-24 h-2 bg-amber-500 mx-auto mt-6 rounded-full shadow-lg shadow-amber-500/20"></div>
                    <p className="mt-6 max-w-2xl text-lg text-slate-500 mx-auto font-medium leading-relaxed px-4">
                        We provide comprehensive travel solutions to make your journey completely hassle-free and unforgettable.
                    </p>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                    {services.length === 0 ? (
                        <div className="col-span-full text-center text-slate-400 py-20 flex flex-col items-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500 mb-4"></div>
                            <p className="font-bold tracking-widest uppercase text-xs">Loading services...</p>
                        </div>
                    ) : (
                        services.map((service) => (
                            <div key={service._id} className="bg-white p-10 rounded-[2.5rem] shadow-sm border border-slate-100 hover:shadow-2xl hover:shadow-amber-500/5 transition-all duration-500 transform hover:-translate-y-2 group flex flex-col h-full border-b-[6px] hover:border-b-amber-500">
                                <div className="w-16 h-16 bg-slate-50 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-amber-500 group-hover:text-white transition-all duration-500 shadow-inner group-hover:rotate-6">
                                    <i className={`${service.icon} text-3xl text-amber-500 group-hover:text-white transition-colors`}></i>
                                </div>
                                <h5 className="text-2xl font-black text-slate-900 mb-4 tracking-tight">{service.title}</h5>
                                <p className="text-slate-500 mb-8 flex-grow leading-relaxed font-medium">{service.description}</p>
                                
                                <button 
                                    onClick={() => handleRequestService(service)}
                                    className="w-full bg-slate-900 text-white hover:bg-amber-500 hover:text-slate-900 font-black py-4 px-6 rounded-2xl transition-all duration-300 mt-auto uppercase tracking-widest text-sm shadow-xl hover:shadow-amber-500/20"
                                >
                                    Request Service
                                </button>
                            </div>
                        ))
                    )}
               </div>
            </div>
        </div>
    );
};

export default Services;